/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateSubscriptionBody { 
    /**
     *  monthly Monthly yearly Yearly
     */
    interval: UpdateSubscriptionBody.IntervalEnum;
    plan: string;
    return_to?: string;
}
export namespace UpdateSubscriptionBody {
    export type IntervalEnum = 'monthly' | 'yearly';
    export const IntervalEnum = {
        Monthly: 'monthly' as IntervalEnum,
        Yearly: 'yearly' as IntervalEnum
    };
}


